import { inject, Injectable } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthState, SigninWithCredentialsOptions } from '@okta/okta-auth-js';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OktaAuthService {
  private oktaAuth = inject(OKTA_AUTH);
  private oktaAuthService = inject(OktaAuthStateService);

  constructor() { }


  public isAuthenticated$ = this.oktaAuthService.authState$.pipe(
    filter((authState: AuthState) => !!authState),
    map((authState: AuthState) => authState.isAuthenticated ?? false)
  );

  async isAuthenticated(): Promise<boolean> {
    return this.oktaAuth.isAuthenticated();
  }

  async getUser(): Promise<any> {
    return this.oktaAuth.getUser();
  }
  async login() {
    await this.oktaAuth.signInWithRedirect({originalUri: '/Home'});
  }

  loginWithCredentials(credentials: SigninWithCredentialsOptions) {
    this.oktaAuth.signInWithCredentials(credentials);
  }

  async logout(): Promise<void> {
    this.oktaAuth.signOut();
  }
}
